import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { AppCookieService } from 'src/app/utils/AppCookieService';

@Injectable({
  providedIn: 'root'
})
export class JWTTokenServiceService {
  private token: string | null = null;
  private decodedToken: any = null;

  constructor(private cookies: AppCookieService) {}

  getToken(): string | null {
    this.token = this.cookies.get("token");
    return this.token;
  }

  setToken(token: string): void {
    this.cookies.set("token", token);
  }

  decodeToken(): void {
    const rawToken = this.getToken();
    if (rawToken && rawToken.split('.').length === 3) {
      try {
        this.decodedToken = jwtDecode(rawToken);
      } catch (error) {
        console.error("Failed to decode token:", error);
        this.decodedToken = null;
      }
    } else {
      console.warn("Invalid token format:", rawToken);
      this.decodedToken = null;
    }
  }

  getDecodeToken(): any {
    this.decodeToken();
    return this.decodedToken;
  }

  getUser(): string | null {
    this.decodeToken();
    return this.decodedToken ? this.decodedToken.displayname : null;
  }

  getEmailId(): string | null {
    this.decodeToken();
    return this.decodedToken ? this.decodedToken.email : null;
  }

  getExpiryTime(): number | null {
    this.decodeToken();
    return this.decodedToken ? this.decodedToken.exp : null;
  }

  isTokenExpired(): boolean {
    const expiryTime: number | null = this.getExpiryTime();
    if (expiryTime) {
      return ((1000 * expiryTime) - Date.now()) < 5000;
    }
    return true; // if no token or invalid token → treat as expired
  }
}
